import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';

const SearchBarGraph = ({ onSearch, onReset, searchTerm: parentSearchTerm, searchOptions, selectedOptions, onSearchByChange }) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState(parentSearchTerm || '');
  const [isFocused, setIsFocused] = useState(false);
  const [searchBy, setSearchBy] = useState(selectedOptions || searchOptions[0]?.value || ''); // Default to selectedOptions or the first option

  useEffect(() => {
    setSearchTerm(parentSearchTerm || '');
  }, [parentSearchTerm]); // Update searchTerm state when parentSearchTerm prop changes

  useEffect(() => {
    if (selectedOptions) {
      setSearchBy(selectedOptions);
    }
  }, [selectedOptions]); // Update searchBy state when selectedOptions prop changes

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSearchByChange = (event) => {
    const newSearchBy = event.target.value;
    setSearchBy(newSearchBy);
    if (onSearchByChange) {
      onSearchByChange(newSearchBy, searchBy);
    }
  };

  const handleSubmit = () => {
    const alphanumericWithDashRegex = /^[a-zA-Z0-9+_.,()?!@ -]+$/;
    const trimmedSearchTerm = searchTerm ? searchTerm.trim() : '';
    if (!alphanumericWithDashRegex.test(trimmedSearchTerm)) {
      Swal.fire({
        toast: true,
        title: t('No special characters in search term'),
        position: "top",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        padding: "1em",
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        }
      });
      return;
    }
    if (searchBy === '') {
      // Special case for "All"
      onSearch(null, trimmedSearchTerm);
    } else {
      const filters = { [`${searchBy}Ilike`]: `${trimmedSearchTerm}` };
      onSearch(filters, trimmedSearchTerm);
    }
  };

  const handleReset = () => {
    setSearchTerm('');
    setSearchBy(searchOptions[0]?.value || '');
    if (onReset) {
      onReset();
    }
  };

  const handleKeyDown = (event) => {
    if (isFocused === true) {
      if (event.key === 'Enter') {
        handleSubmit();
      }
    }
  };

  const handleInputFocus = () => {
    setIsFocused(true);
  };

  const handleInputBlur = () => {
    setIsFocused(false);
  };

  return (
    <div className="search-container flex items-stretch space-x-2">
      <div className="flex items-center px-1 py-1 border border-gray-300 border-solid rounded focus-within:ring-2 focus-within:ring-blue-500">
        <select
          className="h-full px-2 bg-gray-100 border-none outline-none rounded filter_in_search"
          value={searchBy}
          onChange={handleSearchByChange}
        >
          {searchOptions.map((option) => (
            <option key={option.label} value={option.value}>
              {t(option.label)}
            </option>
          ))}
        </select>

        <input
          type="text"
          placeholder={t("Search...")}
          value={searchTerm}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          className="!px-4 py-1 border-0 outline-none text-sm flex-1 border-none bg-transparent"
        />
      </div>

      <button onClick={handleSubmit} className="px-4 py-2 bg-blue-500 text-white rounded">
        {t('Search')}
      </button>

      <button type="button" onClick={handleReset} className="px-4 py-2 bg-[#a3a3a3] rounded">
        {t('Reset')}
      </button>
    </div>
  );
};

export default SearchBarGraph;